/* Componente per selezionare l'operatore per eseguire la query*/
import React from 'react';
import {useEffect} from 'react'
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
const useStyles = makeStyles((theme) => ({
  selectEmpty: {
    marginTop: theme.spacing(0),
  },
}));

function SelectOperator(props) {
  var dataLayers = []
  const classes = useStyles();
  const [status, setStatus] = React.useState('');

  try {
      
      dataLayers = props.operator
   
  } catch (error) {
    
  }
  useEffect(()=>{
    setStatus('')
    // setLayerValue('')
  },[props.start])

  const handleChange = (event) => {
    props.callback(dataLayers[event.target.value])
    setStatus(event.target.value);
 //setLayerValue(dataLayers[event.target.value])
  };
  const select =(dati,index)=>{
      return (
        <MenuItem key={index} value={index} >
        {dati.name}
      </MenuItem>)
  }

  return (
    
        <FormControl className={"formControl"} >
          {/* <h1>{props.start}</h1> */}
        <Select
        
          value={status}
          onChange={handleChange}
          displayEmpty
          className={classes.selectEmpty}
          inputProps={{ 'aria-label': 'Without label' }}
          
        >
          {dataLayers.map((item, index) => (
            
              select(item,index)
          ))}
            
            {/* <MenuItem value={"data2"}>{"data2"}</MenuItem> */}
        </Select>
      </FormControl>
   )}


  export default SelectOperator